<template>
  <v-card
    class="elevation-1 pa-3"
  >
    <div class="address-info">
      <div
        v-if="title"
        class="d-flex align-center"
      >
        <v-icon color="#445959" class="mr-1">mdi-star</v-icon> &nbsp;
        <strong>{{ title }}</strong>
      </div>
      <div>{{ value.firstname }} {{ value.lastname }}</div>
      <div v-html="(value.address || '').replace('\n', '<br />')"></div>
      <div>{{ value.city }}</div>
      <div>{{ value.state }}<span v-if="value.state || value.country">,</span> {{ value.country }}  {{ value.zipcode }}</div>
      <div>{{ value.phone }}</div>
    </div>
    <div class="d-flex justify-end">
      <div>
        <v-menu
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              small
              v-on="on"
              v-bind="attrs"
              :disabled="loading"
            >Change
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-if="value.default_s !== 'Y'"
              @click="update({ default_s: 'Y' })"
            >
              <v-list-item-title>Make Default Shipping</v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="value.default_b !== 'Y'"
              @click="update({ default_b: 'Y' })"
            >
              <v-list-item-title>Make Default Billing</v-list-item-title>
            </v-list-item>
            <v-list-item
              :to="{ name: 'AddressEditor', params: { addressId: value.id } }"
            >
              <v-list-item-title>Change Address</v-list-item-title>
            </v-list-item>
            <v-list-item
              @click.stop="destroy"
            >
              <v-list-item-title>Delete</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
  </v-card>
</template>

<style lang="scss" scoped>
.address-info {
  margin-top: 4px;
  font-size: 14px;
  min-height: 150px;
}
</style>

<script>
import { Address } from '@/models'

export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    async update (props = {}) {
      this.loading = true
      try {
        await Address.save({
          ...this.value,
          ...props
        })
        this.loading = false
        // Update other records that were default
        if (props.default_s === 'Y') {
          Address.query().where(r => r.id + '' !== this.value.id + '' && r.default_s === 'Y').get().forEach(r => {
            Address.update({
              where: r.id,
              data: {
                default_s: 'N'
              }
            })
          })
        }
        if (props.default_b === 'Y') {
          Address.query().where(r => r.id + '' !== this.value.id + '' && r.default_b === 'Y').get().forEach(r => {
            Address.update({
              where: r.id,
              data: {
                default_b: 'N'
              }
            })
          })
        }
      } catch (e) {
        this.loading = false
        throw e
      }
    },
    async destroy () {
      if (!window.confirm('Are you sure you want to delete this address?')) {
        return
      }
      await Address.destroy(this.value)
    }
  }
}
</script>
